import { IService } from './IService';
import { AngularFireDatabase } from '@angular/fire/database';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppSettings } from './app-settings';
import { ToastService } from './toast-service';
import { LoadingService } from './loading-service';

@Injectable({ providedIn: 'root' })
export class ListViewExpandableService implements IService {

  constructor(public af: AngularFireDatabase, private loadingService: LoadingService, private toastCtrl: ToastService) { }

  getId = (): string => 'expandable';

  getTitle = (): string => 'Expandable';

  getAllThemes = (): Array<any> => {
    return [
      { 'url': 'expandable/0', 'title': 'List With Avatar', 'theme': 'layout1' },
      { 'url': 'expandable/1', 'title': 'Full With Card', 'theme': 'layout2' },
      { 'url': 'expandable/2', 'title': 'Full With Image', 'theme': 'layout3' }
    ];
  }

  getDataForTheme = (menuItem: any): Array<any> => {
    return this[
      'getDataFor' +
      menuItem.theme.charAt(0).toUpperCase() +
      menuItem.theme.slice(1)
    ]();
  }

  //* Data Set for page 1
  getDataForLayout1 = (): any => {
    return {
      'toolbarTitle': 'List With Avatar',
      'items': [
        {
          'id': 1,
          'title': 'Sofia Madsen',
          'description': 'jhunt@mider.com',
          'image': 'assets/imgs/avatar/24.jpg',
          'icon': 'chevron-down',
          'items': [
            {
              'id': 1,
              'title': 'Main Street 32, NYC',
              'icon': 'location'
            },
            {
              'id': 2,
              'title': '+ 1 233 9843 2354',
              'icon': 'call'
            }
          ]
        },
        {
          'id': 2,
          'title': 'Benton Willis',
          'description': 'jhunt@mider.com',
          'image': 'assets/imgs/avatar/23.jpg',
          'icon': 'chevron-down',
          'items': [
            {
              'id': 1,
              'title': 'Main Street 32, NYC',
              'icon': 'location'
            },
            {
              'id': 2,
              'title': '+ 1 233 9843 2354',
              'icon': 'call'
            }
          ]
        },
        {
          'id': 3,
          'title': 'Carolyn Guerrero',
          'description': 'jhunt@mider.com',
          'image': 'assets/imgs/avatar/17.jpg',
          'icon': 'chevron-down',
          'items': [
            {
              'id': 1,
              'title': 'Main Street 32, NYC',
              'icon': 'location'
            },
            {
              'id': 2,
              'title': '+ 1 233 9843 2354',
              'icon': 'call'
            }
          ]
        },
        {
          'id': 4,
          'title': 'Benton Willis',
          'description': 'jhunt@mider.com',
          'image': 'assets/imgs/avatar/18.jpg',
          'icon': 'chevron-down',
          'items': [
            {
              'id': 1,
              'title': 'Main Street 32, NYC',
              'icon': 'location'
            },
            {
              'id': 2,
              'title': '+ 1 233 9843 2354',
              'icon': 'call'
            }
          ]
        },
        {
          'id': 5,
          'title': 'Benton Willis',
          'description': 'jhunt@mider.com',
          'image': 'assets/imgs/avatar/19.jpg',
          'icon': 'chevron-down',
          'items': [
            {
              'id': 1,
              'title': 'Main Street 32, NYC',
              'icon': 'location'
            },
            {
              'id': 2,
              'title': '+ 1 233 9843 2354',
              'icon': 'call'
            }
          ]
        },
        {
          'id': 6,
          'title': 'Benton Willis',
          'description': 'jhunt@mider.com',
          'image': 'assets/imgs/avatar/20.jpg',
          'icon': 'chevron-down',
          'items': [
            {
              'id': 1,
              'title': 'Main Street 32, NYC',
              'icon': 'location'
            },
            {
              'id': 2,
              'title': '+ 1 233 9843 2354',
              'icon': 'call'
            }
          ]
        },
        {
          'id': 7,
          'title': 'Benton Willis',
          'description': 'jhunt@mider.com',
          'image': 'assets/imgs/avatar/21.jpg',
          'icon': 'chevron-down',
          'items': [
            {
              'id': 1,
              'title': 'Main Street 32, NYC',
              'icon': 'location'
            },
            {
              'id': 2,
              'title': '+ 1 233 9843 2354',
              'icon': 'call'
            }
          ]
        }
      ]
    };
  }

  //* Data Set for page 2
  getDataForLayout2 = (): any => {
    return {
      'toolbarTitle': 'Full With Card',
      'items': [
        {
          'id': 1,
          'title': 'Bike Black',
          'backgroundImage': 'assets/imgs/background/8.jpg',
          'button': 'Read more',
          'items': [
            {
              'id': 1,
              'description': 'Lorem Ipsum is simply dummy text of the printing',
            },
            {
              'id': 2,
              'description': 'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letter',
            },
          ]
        },
        {
          'id': 2,
          'title': 'Bike Bolt Blue',
          'backgroundImage': 'assets/imgs/background/12.jpg',
          'button': 'Read more',
          'items': [
            {
              'id': 1,
              'description': 'Lorem Ipsum is simply dummy text of the printing',
            },
            {
              'id': 2,
              'description': 'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letter',
            },
          ]
        },
        {
          'id': 3,
          'title': 'Bike Bolt White',
          'backgroundImage': 'assets/imgs/background/10.jpg',
          'button': 'Read more',
          'items': [
            {
              'id': 1,
              'description': 'Lorem Ipsum is simply dummy text of the printing',
            },
            {
              'id': 2,
              'description': 'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letter',
            },
          ]
        },
        {
          'id': 4,
          'title': 'Bike White',
          'backgroundImage': 'assets/imgs/background/11.jpg',
          'button': 'Read more',
          'items': [
            {
              'id': 1,
              'description': 'Lorem Ipsum is simply dummy text of the printing',
            },
            {
              'id': 2,
              'description': 'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letter',
            },
          ]
        }
      ]
    };
  }

  //* Data Set for page 3
  getDataForLayout3 = (): any => {
    return {
      'toolbarTitle': 'Full With Image',
      'items': [
        {
          'title': 'Nissan 400Z',
          'backgroundImage': 'assets/imgs/background/1.jpg',
          "icon": "chevron-down",
          "items": [
            {
              "id": 1,
              "title": "Lorem Ipsum",
              'description': 'Lorem Ipsum is simply dummy text of the printing',
              "image": "assets/imgs/avatar/1.jpg",
            },
            {
              "id": 2,
              "title": "Lorem Ipsum",
              'description': 'Lorem Ipsum is simply dummy text of the printing',
              "image": "assets/imgs/avatar/2.jpg",
            },
            {
              "id": 3,
              "title": "Lorem Ipsum",
              'description': 'Lorem Ipsum is simply dummy text of the printing',
              "image": "assets/imgs/avatar/3.jpg",
            },
            {
              "id": 4,
              "title": "Lorem Ipsum",
              'description': 'Lorem Ipsum is simply dummy text of the printing',
              "image": "assets/imgs/avatar/4.jpg",
            }
          ]
        },
        {
          'title': 'BMW 5 Series',
          'backgroundImage': 'assets/imgs/background/6.jpg',
          "icon": "chevron-down",
          "items": [
            {
              "id": 1,
              "title": "Lorem Ipsum",
              'description': 'Lorem Ipsum is simply dummy text of the printing',
              "image": "assets/imgs/avatar/1.jpg",
            },
            {
              "id": 2,
              "title": "Lorem Ipsum",
              'description': 'Lorem Ipsum is simply dummy text of the printing',
              "image": "assets/imgs/avatar/2.jpg",
            },
            {
              "id": 3,
              "title": "Lorem Ipsum",
              'description': 'Lorem Ipsum is simply dummy text of the printing',
              "image": "assets/imgs/avatar/3.jpg",
            },
            {
              "id": 4,
              "title": "Lorem Ipsum",
              'description': 'Lorem Ipsum is simply dummy text of the printing',
              "image": "assets/imgs/avatar/4.jpg",
            }
          ]
        },
        {
          'title': 'Mitsubishi Eclipse',
          'backgroundImage': 'assets/imgs/background/2.jpg',
          "icon": "chevron-down",
          "items": [
            {
              "id": 1,
              "title": "Lorem Ipsum",
              'description': 'Lorem Ipsum is simply dummy text of the printing',
              "image": "assets/imgs/avatar/1.jpg",
            },
            {
              "id": 2,
              "title": "Lorem Ipsum",
              'description': 'Lorem Ipsum is simply dummy text of the printing',
              "image": "assets/imgs/avatar/2.jpg",
            },
            {
              "id": 3,
              "title": "Lorem Ipsum",
              'description': 'Lorem Ipsum is simply dummy text of the printing',
              "image": "assets/imgs/avatar/3.jpg",
            },
            {
              "id": 4,
              "title": "Lorem Ipsum",
              'description': 'Lorem Ipsum is simply dummy text of the printing',
              "image": "assets/imgs/avatar/4.jpg",
            }
          ]
        },
        {
          'title': 'Mazda CX-30 Turbo',
          'backgroundImage': 'assets/imgs/background/5.jpg',
          "icon": "chevron-down",
          "items": [
            {
              "id": 1,
              "title": "Lorem Ipsum",
              'description': 'Lorem Ipsum is simply dummy text of the printing',
              "image": "assets/imgs/avatar/1.jpg",
            },
            {
              "id": 2,
              "title": "Lorem Ipsum",
              'description': 'Lorem Ipsum is simply dummy text of the printing',
              "image": "assets/imgs/avatar/2.jpg",
            },
            {
              "id": 3,
              "title": "Lorem Ipsum",
              'description': 'Lorem Ipsum is simply dummy text of the printing',
              "image": "assets/imgs/avatar/3.jpg",
            },
            {
              "id": 4,
              "title": "Lorem Ipsum ",
              'description': 'Lorem Ipsum is simply dummy text of the printing',
              "image": "assets/imgs/avatar/4.jpg",
            }
          ]
        }
      ]
    };
  }

  load(item: any): Observable<any> {
    this.loadingService.show();
    if (AppSettings.IS_FIREBASE_ENABLED) {
      return new Observable(observer => {
        this.af
          .object('listView/expandable/' + item.theme)
          .valueChanges()
          .subscribe(snapshot => {
            this.loadingService.hide();
            observer.next(snapshot);
            observer.complete();
          }, err => {
            this.loadingService.hide();
            observer.error([]);
            observer.complete();
          });
      });
    } else {
      return new Observable(observer => {
        this.loadingService.hide();
        observer.next(this.getDataForTheme(item));
        observer.complete();
      });
    }
  }
}
